import style from './Event.module.scss'
import bg from 'assets/images/form-bg.png'

export const Event = ({ children })=> {
    return (
        <div className={style.block}>
             <div className={style.bg}>
                <picture>
                    <img src={bg} alt="" width={1920} height={2600} />
                </picture>
            </div>
            <div className={style.main}>
                {children}
            </div>
        </div>
    )
}